export default {
  // Floating button
  'chatbot.buttonLabel': 'Chat',

  // Header
  'chatbot.headerTitle': 'GB CosPack Assistant',
  'chatbot.headerSubtitle': 'Ask about packaging, quotes, and orders.',

  // Welcome message
  'chatbot.welcomeMessage': 'Hello. I can help with cosmetic packaging selection, quotation requests, AI finishing previews, and order steps.',

  // Starter questions
  'chatbot.starter.0': 'How do I request a quote?',
  'chatbot.starter.1': 'How does MOQ work?',
  'chatbot.starter.2': 'What is AI finishing preview?',
  'chatbot.starter.3': 'Where can I check my order status?',

  // Input
  'chatbot.inputPlaceholder': 'Type your message...',
  'chatbot.send': 'Send',
  'chatbot.close': 'Close',
  'chatbot.newChat': 'New chat',

  // Loading
  'chatbot.loading': 'Generating a response...',

  // Error
  'chatbot.errorMessage': 'Sorry, I could not generate an answer right now. Please try again shortly.',
  'chatbot.notConfigured': 'The chatbot API is not yet connected. Please ask the admin to set the backend URL.',

  // Safety status
  'chatbot.outOfScopeNote': 'Please ask a packaging, quote, or order-related question.',

  // Quote CTA
  'chatbot.quoteCta': 'Request a quote',
  'chatbot.suggestedQuestions': 'Suggested questions',
};